import "./TermsAndConditions.module.css";
import Header from "@/reusable_sections/Header";
import ServiceTermsEditorial from "./sections/ServiceTermsEditorial";
import Legal from "./sections/Legal";
import ContactSplit from "./sections/ContactSplit";
import Footer from "@/reusable_sections/Footer";
export default function TermsAndConditionsPage() {
  return <div>
      <Header />
      <ServiceTermsEditorial />
      <Legal />
      <ContactSplit />
      <Footer />
    </div>;
}